import axios from 'axios';
import Auth from '../lib/auth';
import utilsLib from './utils.lib';
import { addNotification } from './notifications';

export const GET_ALERTS_REQUEST = 'GET_ALERTS_REQUEST';
export const GET_ALERTS_SUCCESS = 'GET_ALERTS_SUCCESS';
export const GET_ALERTS_ERROR = 'GET_ALERTS_ERROR';

export const CHANGE_STATUS_ALERT_REQUEST = 'CHANGE_STATUS_ALERT_REQUEST';
export const CHANGE_STATUS_ALERT_SUCCESS = 'CHANGE_STATUS_ALERT_SUCCESS';
export const CHANGE_STATUS_ALERT_ERROR = 'CHANGE_STATUS_ALERT_ERROR';

export const CLEAN_ALERTS = 'CLEAN_ALERTS';

// Get alerts
export function getAlerts(alertType) {
    return async (dispatch) => {
        try {
            dispatch(getAlertsRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/alerts', alertType, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getAlertsSuccess, getAlertsError));
        } catch (err) {
            dispatch(utilsLib.response(err, getAlertsError));
        }
    };
}
function getAlertsRequest() {
    return {
        type: GET_ALERTS_REQUEST,
        isFetching: true
    };
}
function getAlertsSuccess (payload) {
    return {
        type: GET_ALERTS_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}
function getAlertsError(errorMessage) {
    return {
        type: GET_ALERTS_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Update alert status
export function changeStatusAlert(alertId, status) {
    return async (dispatch) => {
        try {
            dispatch(changeStatusAlertRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.put(`/api/alerts/${alertId}`, { status }, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, changeStatusAlertSuccess, changeStatusAlertError));
        } catch (err) {
            dispatch(utilsLib.response(err, changeStatusAlertError));
        }
    };
}
function changeStatusAlertRequest() {
    return {
        type: CHANGE_STATUS_ALERT_REQUEST,
        isFetching: true
    };
}
function changeStatusAlertSuccess (payload) {
    return dispatch => {
        // Create notification for update alert success
        dispatch(addNotification({
            message: 'Estado de la alerta actualizado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: CHANGE_STATUS_ALERT_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function changeStatusAlertError(errorMessage) {
    return dispatch => {
        // Create notification for update serie error
        dispatch(addNotification({
            message: 'Error al actualizar el estado de la alerta',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: CHANGE_STATUS_ALERT_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Clean alerts reducer
export function cleanAlerts() {
    return {
        type: 'CLEAN_ALERTS',
        isFetching: false,
        error: false,
        payload: []
    }
}



// WEBPACK FOOTER //
// ./src/actions/alerts.js